module.exports = __webpack_public_path__ + "img/step_confirm.2f7aca11.svg";